<template>
    <div v-can:read-tab="'dossiers'">
        <div class="h2">
            Gestion des dossiers
        </div>
        <hr>

        <button
            v-can:exec-action="'dossier.duplicate'"
            class="float-right btn btn-primary mr-2 mb-2"
            @click="showModalDuplicateDossiers = true"
        >
            Dupliquer les dossiers d'une année
        </button>

        <div class="clearfix" />

        <form
            class="mt-3 py-4 shadow px-3"
            @submit.prevent="search"
        >
            <div class="form-row">
                <div class="h4 col-2">
                    Recherche de dossiers
                </div>
                <div
                    v-if="optionsRecherchesSauvegardees.length"
                    class="col-2"
                    :class="{'offset-8': !$store.getters.can('exec-action', 'recherche.add'), 'offset-6': $store.getters.can('exec-action', 'recherche.add')}"
                >
                    <base-select
                        v-model="rechercheSelectionnee"
                        :options="optionsRecherchesSauvegardees"
                    >
                        Recherches sauvegardées
                    </base-select>
                </div>
                <div
                    v-if="!rechercheSelectionnee"
                    v-can:exec-action="'recherche.add'"
                    class="col-2"
                    :class="{'offset-8': !optionsRecherchesSauvegardees.length}"
                >
                    <a
                        class="text-white btn btn-success mt-3 mb-3 px-4 float-right"
                        @click="showModalEditSearch = true"
                    >
                        Sauvegarder la recherche
                    </a>
                </div>
                <div
                    v-if="rechercheSelectionnee"
                    v-can:exec-action="'recherche.remove'"
                    class="col-2"
                >
                    <a
                        class="text-white btn btn-danger mb-3 mt-3 px-4 float-right"
                        @click="removeSearch(rechercheSelectionnee)"
                    >
                        Supprimer cette recherche
                    </a>
                </div>
            </div>
            <div class="clearfix" />

            <div class="form-row mt-4">
                <div class="col-2">
                    <base-input
                        v-model="params.cegid"
                        :errors="errors.cegid"
                    >
                        Référence (CEGID)
                    </base-input>
                </div>
                <div class="col-2">
                    <base-input
                        v-model="params.client"
                        :errors="errors.client"
                    >
                        Client
                    </base-input>
                </div>
                <div class="col-2">
                    <base-select
                        v-model="params.regime_tva"
                        :errors="errors.regime_tva"
                        :options="optionsRegimesTVA"
                        multiple
                    >
                        Régime TVA
                    </base-select>
                </div>
                <div class="col-2">
                    <base-select
                        v-model="params.mailsAutorises"
                        :options="optionsOuiNon"
                    >
                        Envoi de mail autorisé
                    </base-select>
                </div>
                <div class="col-2">
                    <base-select
                        v-model="params.collaborateurs"
                        :options="addEmptyOption(optionsCollaborateurs)"
                        multiple
                    >
                        Collaborateur
                    </base-select>
                </div>
                <div class="col-2">
                    <base-select
                        v-model="params.administratifs"
                        :options="addEmptyOption(optionsAdministratifs)"
                        multiple
                    >
                        Administratif
                    </base-select>
                </div>
            </div>

            <div class="form-row">
                <div class="col-2">
                    <base-select
                        v-model="params.lieuxProductions"
                        :options="addEmptyOption(optionsLieuxProductions)"
                        multiple
                    >
                        Lieu de production
                    </base-select>
                </div>
                <div class="col-2">
                    <base-select
                        v-model="params.superviseurs"
                        :options="addEmptyOption(optionsSuperviseurs)"
                        multiple
                    >
                        Superviseur
                    </base-select>
                </div>
                <div class="col-2">
                    <base-select
                        v-model="params.equipes"
                        :options="optionsEquipes"
                        multiple
                    >
                        Équipe
                    </base-select>
                </div>
                <div class="col-2">
                    <base-select
                        v-model="params.cabinets"
                        :options="optionsCabinets"
                        multiple
                    >
                        Cabinet
                    </base-select>
                </div>
                <div class="col-2">
                    <base-select
                        v-model="params.cloture"
                        :errors="errors.cloture"
                        :options="optionsClotures"
                        no-search
                        multiple
                    >
                        Clôture
                    </base-select>
                </div>
                <div class="col-2">
                    <base-input
                        v-model="params.exercice"
                        :errors="errors.exercice"
                    >
                        Exercice
                    </base-input>
                </div>
            </div>

            <div class="form-row">
                <div class="col-2">
                    <base-select
                        v-model="params.actif"
                        :options="optionsOuiNon"
                    >
                        Actif
                    </base-select>
                </div>
                <div class="col-2">
                    <base-select
                        v-model="params.clientSorti"
                        :options="optionsOuiNon"
                    >
                        Client sorti ?
                    </base-select>
                </div>
                <div class="col-2">
                    <base-select
                        v-model="params.responsablesTva"
                        :options="addEmptyOption(optionsEquipes)"
                        multiple
                    >
                        Responsable TVA
                    </base-select>
                </div>
                <div class="col-2">
                    <base-select
                        v-model="params.statuts"
                        :options="optionsStatuts"
                        multiple
                    >
                        Statut
                    </base-select>
                </div>
                <div class="col-2">
                    <base-select
                        v-model="params.tva_statuts"
                        :options="optionsTvaStatuts"
                        multiple
                    >
                        Statut de TVA
                    </base-select>
                </div>
                <div class="col-2">
                    <base-select
                        v-model="params.resultatStatuts"
                        :errors="errors.resultatStatuts"
                        :options="optionsResultatStatutsWithNonCrees"
                        no-search
                        multiple
                    >
                        Statut fiche résultat
                    </base-select>
                </div>
            </div>

            <div class="form-row">
                <div class="col-2">
                    <base-select
                        v-model="params.typeMissions"
                        :errors="errors.typeMissions"
                        :options="optionsTypeMissionsWithoutFoncier"
                        multiple
                    >
                        Type de mission
                    </base-select>
                </div>
                <div class="col-2">
                    <base-select
                        v-model="params.dossierSorti"
                        :options="optionsOuiNon"
                    >
                        Dossier sorti ?
                    </base-select>
                </div>
                <div class="col-2">
                    <base-select
                        v-model="params.hasSiret"
                        :options="optionsOuiNon"
                    >
                        Siret reçu ?
                    </base-select>
                </div>
                <div class="col-2">
                    <base-select
                        v-model="params.lieuxCollectes"
                        :options="addEmptyOption(optionsLieuxCollectes)"
                        multiple
                    >
                        Lieu de collecte
                    </base-select>
                </div>
                <transition name="fade">
                    <div
                        v-if="params.statuts && params.statuts.includes($store.state.dossiersStatuts.statutTeletransmis)"
                        class="col-2"
                    >
                        <base-select
                            v-model="params.resultatTransmission"
                            :options="optionsResultatTransmission"
                        >
                            Résultat TT Liasse + CA12
                        </base-select>
                    </div>
                </transition>
                <transition name="fade">
                    <div
                        v-if="params.tva_statuts && params.tva_statuts.includes($store.state.tvaStatuts.statutTeletransmis)"
                        class="col-2"
                    >
                        <base-select
                            v-model="params.resultatTransmissionTva"
                            :options="optionsResultatTransmission"
                        >
                            Résultat TT CA3
                        </base-select>
                    </div>
                </transition>
                <div class="col-2">
                    <base-select
                        v-model="params.typeIndivisions"
                        :errors="errors.typeIndivisions"
                        :options="optionsTypesIndivisions"
                        multiple
                    >
                        Indivision/Société
                    </base-select>
                </div>
                <div class="col-2">
                    <base-select
                        v-model="params.lot_client_statut_id"
                        :errors="errors.lot_client_statut_id"
                        :options="optionsLotClientStatuts"
                        multiple
                    >
                        Statut Lot
                    </base-select>
                </div>
            </div>

            <div class="form-row">
                <div class="col-2">
                    <base-input
                        v-model="params.id_externe_client"
                        type="text"
                    >
                        Identifiant externe client
                    </base-input>
                </div>
                <div class="col-2">
                    <base-input
                        v-model="params.id_externe_lot"
                        type="text"
                    >
                        Identifiant externe lot
                    </base-input>
                </div>
            </div>

            <!--NEW FILTERS-->
            <a
                href="#"
                class="float-right"
                @click.prevent="seeMoreFilters = !seeMoreFilters"
            >
                <template v-if="!seeMoreFilters">
                    <i class="fa fa-plus" />
                    Voir les filtres avancés
                </template>

                <template v-else>
                    <i class="fa fa-minus" />
                    Masquer les filtres avancés
                </template>
            </a>
            <br>
            <transition name="fade">
                <div
                    v-if="seeMoreFilters"
                    class="mt-3"
                >
                    <hr>
                    <div class="form-row">
                        <div class="col-2">
                            <base-select
                                v-model="params.cfe"
                                :options="optionsCfe"
                            >
                                Assujetti CFE
                            </base-select>
                        </div>
                        <div class="col-2">
                            <base-select
                                v-model="params.rib"
                                :options="optionsOuiNonEtNonRenseigne"
                            >
                                RIB
                            </base-select>
                        </div>
                        <div class="col-1">
                            <base-input
                                v-model="params.total_loyer_min"
                                placehoder="minimum"
                                euros
                                show-label
                            >
                                Total loyer
                            </base-input>
                        </div>
                        <div class="col-1">
                            <base-input
                                v-model="params.total_loyer_max"
                                placehoder="maximum"
                                euros
                            />
                        </div>
                        <div class="col-2">
                            <base-select
                                v-model="params.bouvard"
                                :options="optionsBouvard"
                            >
                                Bouvard
                            </base-select>
                        </div>
                        <div class="col-2">
                            <base-select
                                v-model="params.cga"
                                :options="optionsOuiNonEtNonRenseigne"
                            >
                                CGA
                            </base-select>
                        </div>
                        <div class="col-2">
                            <base-select
                                v-model="params.espace_professionnel"
                                :options="[{value: '', label: 'Tous'}, ...optionsEspaceProfessionnel, {value: 999, label: 'Non renseigné'}]"
                            >
                                Espace Professionnel
                            </base-select>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-2">
                            <base-input
                                v-model="params.date_creation_min"
                                type="date"
                            >
                                Création du dossier après le
                            </base-input>
                        </div>
                        <div class="col-2">
                            <base-input
                                v-model="params.date_creation_max"
                                type="date"
                            >
                                Création du dossier avant le
                            </base-input>
                        </div>
                        <div class="col-1">
                            <base-input
                                v-model="params.total_loyer_saisonnier_min"
                                placehoder="minimum"
                                euros
                                show-label
                            >
                                Loyers saisonnier
                            </base-input>
                        </div>
                        <div class="col-1">
                            <base-input
                                v-model="params.total_loyer_saisonnier_max"
                                placehoder="maximum"
                                euros
                            />
                        </div>
                        <div class="col-2">
                            <base-select
                                v-model="params.saisonnier"
                                :options="optionsOuiNon"
                            >
                                Saisonnier
                            </base-select>
                        </div>
                        <div class="col-2">
                            <base-select
                                v-model="params.pro"
                                :options="optionsOuiNon"
                            >
                                Professionnel
                            </base-select>
                        </div>
                        <div class="col-2">
                            <base-select
                                v-model="params.rsi"
                                :options="optionsOuiNon"
                            >
                                RSI
                            </base-select>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-2">
                            <base-input
                                v-model="params.date_reception_min"
                                type="date"
                            >
                                Réception du dossier après le
                            </base-input>
                        </div>
                        <div class="col-2">
                            <base-input
                                v-model="params.date_reception_max"
                                type="date"
                            >
                                Réception du dossier avant le
                            </base-input>
                        </div>
                        <div class="col-1">
                            <base-input
                                v-model="params.resultat_min"
                                :errors="errors.resultat_min"
                                placehoder="minimum"
                                show-label
                                euros
                            >
                                Résultat
                            </base-input>
                        </div>
                        <div class="col-1">
                            <base-input
                                v-model="params.resultat_max"
                                :errors="errors.resultat_max"
                                placehoder="maximum"
                                euros
                            />
                        </div>
                        <div class="col-2">
                            <base-select
                                v-model="params.programme_nom"
                                :options="optionsProgrammeNom"
                                multiple
                            >
                                Nom du programme
                            </base-select>
                        </div>
                        <div class="col-2">
                            <base-select
                                v-model="params.programme_cp"
                                :options="optionsProgrammeCP"
                                multiple
                            >
                                Code postal du programme
                            </base-select>
                        </div>
                        <div class="col-2">
                            <base-select
                                v-model="params.provenances"
                                :options="optionsProvenances"
                                multiple
                            >
                                Provenance
                            </base-select>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-2">
                            <base-input
                                v-model="params.date_debut_activite_min"
                                type="date"
                            >
                                Début d'activité après le
                            </base-input>
                        </div>
                        <div class="col-2">
                            <base-input
                                v-model="params.date_debut_activite_max"
                                type="date"
                            >
                                Début d'activité avant le
                            </base-input>
                        </div>
                        <div class="col-2">
                            <base-select
                                v-model="params.facture_impayee_annee_precedente"
                                :options="optionsOuiNon"
                            >
                                Facture impayée N-1
                            </base-select>
                        </div>
                        <div class="col-2">
                            <base-select
                                v-model="params.supervision"
                                :options="optionsSupervisions"
                            >
                                Supervision
                            </base-select>
                        </div>
                        <div class="col-2">
                            <base-select
                                v-model="params.changement_semaine_derniere"
                                :options="optionsChangementSemaineDerniere"
                            >
                                Changement semaine dernière
                            </base-select>
                        </div>
                        <div class="col-2">
                            <base-select
                                v-model="params.gestion_locative"
                                :options="optionsOuiNon"
                            >
                                Gestion Locative
                            </base-select>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-2">
                            <base-select
                                v-model="params.retro"
                                :options="optionsRetro"
                            >
                                Type rétro
                            </base-select>
                        </div>
                        <div class="col-2">
                            <base-select
                                v-model="params.mode_detention"
                                :options="optionsModeDetention"
                                multiple
                            >
                                Mode de détention
                            </base-select>
                        </div>
                        <div class="col-2">
                            <base-select
                                v-model="params.type"
                                :errors="errors.type"
                                :options="optionsTypeDossier"
                                multiple
                            >
                                Type de dossier
                            </base-select>
                        </div>
                        <div class="col-2">
                            <base-select
                                v-model="params.is_chronophage"
                                :options="optionsOuiNon"
                            >
                                Dossiers chronophages
                            </base-select>
                        </div>
                        <div class="col-2">
                            <base-select
                                v-model="params.mandat_tva_envoye"
                                :options="optionsOuiNon"
                            >
                                Mandat TVA envoyé
                            </base-select>
                        </div>
                        <div class="col-2">
                            <base-select
                                v-model="params.memento_fiscal"
                                :options="optionsOuiNon"
                            >
                                Memento fiscal
                            </base-select>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-2">
                            <base-select
                                v-model="params.adminTeletransmissions"
                                :options="addEmptyOption(optionsAdministratifs)"
                                multiple
                            >
                                Admin TT
                            </base-select>
                        </div>
                        <div class="col-2">
                            <base-select
                                v-model="params.plafonnement_cfe"
                                :options="optionsOuiNonEtNonRenseigne"
                            >
                                Plafonnement CFE
                            </base-select>
                        </div>
                        <div class="col-2">
                            <base-select
                                v-model="params.collaborateursTva"
                                :options="addEmptyOption(optionsCollaborateurs)"
                                multiple
                            >
                                Collaborateur TVA
                            </base-select>
                        </div>
                        <div
                            class="col-2"
                        >
                            <base-select
                                v-model="params.trimestreTva"
                                :options="addEmptyOption(optionsTrimestre)"
                            >
                                Trimestre TVA
                            </base-select>
                        </div>
                        <div class="col-2">
                            <base-select
                                v-model="params.is_mail_simplifie"
                                :options="optionsTypeMailCollecte"
                                multiple
                            >
                                Type mail collecte
                            </base-select>
                        </div>
                        <div class="col-2">
                            <base-select
                                v-model="params.is_cosmo"
                                :options="optionsOuiNon"
                            >
                                Collecte Cosmo
                            </base-select>
                        </div>
                        <div class="col-2">
                            <base-input
                                v-model="params.date_programmes_importee_min"
                                type="date"
                            >
                                Programmes importés après le
                            </base-input>
                        </div>
                        <div class="col-2">
                            <base-input
                                v-model="params.date_programmes_importee_max"
                                type="date"
                            >
                                Programmes importés avant le
                            </base-input>
                        </div>
                        <div class="col-2">
                            <base-input
                                v-model="params.email"
                                :errors="errors.email"
                            >
                                Email
                            </base-input>
                        </div>
                        <div class="col-2">
                            <base-select
                                v-model="params.logiciel_compta"
                                :options="optionsLogicielCompta"
                                multiple
                            >
                                Logiciel de Comptabilité
                            </base-select>
                        </div>
                        <div class="col-2">
                            <base-select
                                v-model="params.pack"
                                :options="optionsPack"
                                multiple
                            >
                                Pack
                            </base-select>
                        </div>
                        <div class="col-2">
                            <base-select
                                v-model="params.has_bank_account"
                                :options="optionsOuiNon"
                            >
                                Compte bancaire dédié
                            </base-select>
                        </div>
                    </div>
                </div>
            </transition>

            <button
                type="submit"
                class="btn btn-success mt-3 px-4 float-right"
            >
                Rechercher
            </button>

            <button
                class="btn btn-info mt-3 px-4 mr-2 float-right"
                @click.prevent="reinit"
            >
                Réinitialiser
            </button>

            <span class="clearfix" />
        </form>

        <base-table
            :items="items"
            :meta="meta"
            :params="exParams"
            :loading="loading"
            :head="head"
            name="dossier"
            class="mt-5"
            @orderBy="orderBy"
            @change-page="goToPage"
            @paginate="paginate"
            @export="exportExcel"
        >
            <div
                slot="extra-buttons"
                class="d-inline-block"
            >
                <button
                    v-can:exec-action="'mails.collecte_pieces_comptables'"
                    class="btn btn-secondary btn-sm ml-2"
                    :title="'Ce bouton permet de lister et d\'envoyer massivement les mails de collecte des pièces comptables ' +
                        'et les envoyer à tous les clients pour lesquels l\'envoie de mail est activé (information fiche client).'"
                    :disabled="!params.exercice"
                    @click="showModalGenerationMails = true"
                >
                    Générer mails collecte pièces comptables
                </button>

                <button
                    v-can:exec-action="'mails.relance_non_retour'"
                    class="btn btn-secondary btn-sm ml-2"
                    :title="'Ce bouton permet de lister et d\'envoyer massivement les mails de relance ' +
                        'et les envoyer à tous les clients pour lesquels l\'envoie de mail est activé (information fiche client).'"
                    :disabled="!params.exercice"
                    @click="showModalRelanceMails = true"
                >
                    Générer mails relance non-retour
                </button>

                <button
                    v-can:exec-action="'mails.personnalise_massif'"
                    class="btn btn-secondary btn-sm ml-2"
                    :title="'Ce bouton permet de lister et d\'envoyer massivement un mail personnalisé ' +
                        'et les envoyer à tous les clients pour lesquels l\'envoie de mail est activé (information fiche client).'"
                    :disabled="!params.exercice"
                    @click="showModalMailsPersonnalise = true"
                >
                    Rédiger nouveau mail massif
                </button>

                <button
                    v-can:exec-action="'dossier.modification_massive'"
                    class="btn btn-secondary btn-sm ml-2"
                    :title="'Ce bouton permet de modifier des champs en série.'"
                    :disabled="!params.exercice"
                    @click="showModalMassModification = true"
                >
                    Modifier les champs en série
                </button>
            </div>

            <tr
                v-for="dossier of items"
                :key="dossier.id"
                :class="{'text-danger': !dossier.is_actif, 'strikethrough': !dossier.is_actif}"
            >
                <td>{{ dossier.cegid }}</td>
                <td>
                    <template v-if="dossier.type === 'foncier'">
                        Foncier
                    </template>

                    <template v-if="dossier.client.is_indivision">
                        {{ dossier.client.type_indivision }} {{ dossier.client.libelle_indivision }}
                    </template>
                    <template v-else>
                        {{ dossier.client.nom }} {{ dossier.client.prenom }}
                    </template>
                </td>
                <td>{{ dossier.client.telephone }}</td>
                <td>{{ dossier.client.email }}</td>
                <td>{{ dossier.date_debut_activite | frenchDate }}</td>
                <td>{{ dossier.is_cga ? 'Oui' : 'Non' }}</td>
                <td>{{ dossier.regime_tva }}</td>
                <td>{{ dossier.date_cloture | dateCloture }}</td>
                <td>{{ dossier.date_reception | frenchDate }}</td>
                <td>{{ dossier.cabinet !== null ? dossier.cabinet.nom : '' }}</td>
                <td>{{ dossier.equipe !== null ? dossier.equipe.nom : '' }}</td>
                <td>{{ dossier.updated_at_global | frenchDateTime }}</td>
                <td>{{ dossier.statut !== null ? dossier.statut.nom : '' }}</td>
                <td class="text-center">
                    <router-link
                        v-can:read-model="'dossier'"
                        :to="{name: 'dossier', params: {id: dossier.id}}"
                        class="btn btn-primary btn-sm"
                        title="Voir"
                    >
                        <i class="fa fa-glasses" />
                    </router-link>
                </td>
            </tr>
        </base-table>

        <GenererMailsCollecteModal
            v-if="showModalGenerationMails"
            :additional-params="exParams"
            @close="showModalGenerationMails = false"
        />

        <GenererMailsRelanceModal
            v-if="showModalRelanceMails"
            :additional-params="exParams"
            @close="showModalRelanceMails = false"
        />

        <SelectionDossiersDeClientsModal
            v-if="showModalMailsPersonnalise"
            :additional-params="exParams"
            :exercice="params.exercice"
            @close="showModalMailsPersonnalise = false"
            @next-step="nextStepMailsPersonnalises"
        />

        <SelectionMassModificationModal
            v-if="showModalMassModification"
            :additional-params="exParams"
            emplacement="dossier"
            @close="search(); showModalMassModification = false"
        />

        <SearchEditModal
            v-if="showModalEditSearch"
            :filters="params"
            @close="showModalEditSearch = null"
            @reload="reloadRechercheSelectionnee"
        />

        <MailEditModal
            v-if="showModalEditMail !== null"
            :mail="showModalEditMail"
            :dossiers="dossiersId"
            @close="showModalEditMail = null"
            @reload="search()"
        />

        <DuplicateDossiersModal
            v-if="showModalDuplicateDossiers"
            @close="showModalDuplicateDossiers = false"
        />
    </div>
</template>

<script>
    import BaseInput from "../templates/BaseInput"
    import BaseSelect from "../templates/BaseSelect"
    import GenererMailsCollecteModal from "../modals/GenererMailsCollecteModal"
    import GenererMailsRelanceModal from "../modals/GenererMailsRelanceModal"
    import DossierSearch from "../../mixins/DossierSearch"
    import BaseTable from "../templates/BaseTable"
    import {mapGetters} from "vuex"
    import DuplicateDossiersModal from "../modals/DuplicateDossiersModal"
    import SelectionDossiersDeClientsModal from "../modals/SelectionDossiersDeClientsModal"
    import SelectionMassModificationModal from "../modals/SelectionMassModificationModal"
    import MailEditModal from "../modals/MailEditModal"
    import SearchEditModal from "../modals/SearchEditModal"

    export default {
        name: "DossiersList",

        components: {
            SelectionDossiersDeClientsModal,
            SelectionMassModificationModal,
            DuplicateDossiersModal,
            BaseTable,
            GenererMailsCollecteModal,
            GenererMailsRelanceModal,
            BaseSelect,
            BaseInput,
            MailEditModal,
            SearchEditModal,
        },

        mixins: [DossierSearch],

        data: function() {
            return {
                changeSearch: false,

                params: this.initParams(),

                rechercheSelectionnee: 0,

                head: {
                    cegid: "CEGID",
                    client: "Client",
                    telephone: "Téléphone",
                    email: "Email",
                    date_debut_activite: "Date début d'activité",
                    is_cga: "CGA",
                    regime_tva: "Régime TVA",
                    date_cloture: "Date de clôture",
                    date_reception: "Date de réception",
                    cabinet: "Cabinet",
                    equipe: "Équipe",
                    updated_at_global: "Dernière modification",
                    statut: "Statut",
                },

                optionsOuiNon: [
                    {value: '', label: 'Tous'},
                    {value: 1, label: 'Oui'},
                    {value: 0, label: 'Non'},
                ],

                optionsOuiNonEtNonRenseigne: [
                    {value: '', label: 'Tous'},
                    {value: 1, label: 'Oui'},
                    {value: 0, label: 'Non'},
                    {value: 999, label: 'Non renseigné'},
                ],

                optionsCfe: [
                    {value: '', label: 'Tous'},
                    {value: 2, label: 'Oui Cabinet'},
                    {value: 1, label: 'Oui Client'},
                    {value: 0, label: 'Non'},
                    {value: 999, label: 'Non renseigné'},
                ],

                optionsResultatTransmission: [
                    {value: '', label: 'Tous'},
                    {value: 'ok', label: 'Ok'},
                    {value: 'rejet', label: 'Rejet'},
                    {value: 'aucun', label: 'Aucun résultat'},
                ],

                optionsBouvard: [
                    {label: 'Tous', value: ''},
                    {label: 'Oui', value: 1},
                    {label: 'Non', value: 0},
                    {label: 'En attente', value: 2},
                ],

                optionsSupervisions: [
                    {label: 'Tous', value: ''},
                    {label: 'Avec correction(s)', value: 1},
                    {label: 'Sans correction', value: 0},
                ],

                optionsChangementSemaineDerniere: [
                    {label: 'Tous', value: ''},
                    {label: 'Entrée semaine dernière', value: 1},
                    {label: 'Sortie semaine dernière', value: 0},
                ],

                optionsTrimestre: [
                    {label: '1er trimestre', value: 1},
                    {label: '2eme trimestre', value: 2},
                    {label: '3eme trimestre', value: 3},
                    {label: '4eme trimestre', value: 4},
                ],

                showModalGenerationMails: false,
                showModalRelanceMails: null,
                showModalMailsPersonnalise: false,
                showModalMassModification: false,
                showModalDuplicateDossiers: false,
                seeMoreFilters: false,
                showModalEditMail: null,
                showModalEditSearch: null,

                dossiersId: [],
            }
        },

        computed: {
            optionsResultatStatutsWithNonCrees: function () {
                return [{value: '', label: 'Non créé'}].concat(this.$store.getters.optionsResultatStatuts)
            },

            ...mapGetters([
                'optionsEquipes',
                'optionsCabinets',
                'optionsStatuts',
                'optionsUsers',
                'optionsLieuxProductions',
                'optionsSuperviseurs',
                'optionsAdministratifs',
                'optionsCollaborateurs',
                'optionsClotures',
                'optionsRegimesTVA',
                'optionsLogicielCompta',
                'optionsPack',
                'optionsLieuxCollectes',
                'optionsTvaStatuts',
                'optionsTypeMissionsWithoutFoncier',
                'optionsResultatStatuts',
                'optionsProgrammeCP',
                'optionsProgrammeNom',
                'optionsProvenances',
                'optionsRecherchesSauvegardees',
                'getRecherchesSauvegardees',
                'optionsTypeDossier',
                'optionsTypesIndivisions',
                'optionsRetro',
                'optionsModeDetention',
                'optionsEspaceProfessionnel',
                'optionsLotClientStatuts',
                'me'
            ]),

            optionsTypeMailCollecte: function () {
                return [
                    {value: 0, label: 'Classique'},
                    {value: 1, label: 'Simplifié'},
                    {value: 2, label: 'Société'},
                ]
            },
        },

        watch: {
            params: {
                // This will let Vue know to look inside the array
                deep: true,

                // We have to move our method to a handler field
                handler() {
                    this.$router.replace(_.omit(this.$route.query, 'recherche'))

                    if (!this.changeSearch) {
                        this.rechercheSelectionnee = null
                    }
                    this.changeSearch = false
                    this.updateRechercheSelectionnee()
                }
            },

            'params.statuts': function (values) {
                if (!values || !values.includes(this.$store.state.dossiersStatuts.statutTeletransmis)) {
                    this.$set(this.params, 'resultatTransmission', null)
                }
            },

            'params.tva_statuts': function (values) {
                if (!values || !values.includes(this.$store.state.tvaStatuts.statutTeletransmis)) {
                    this.$set(this.params, 'resultatTransmissionTva', null)
                }
            },

            'rechercheSelectionnee': function (value) {
                if (!value) {
                    return
                }
                const filters = this.getRecherchesSauvegardees.filter(filter => filter.id === value)

                if (filters.length >= 1) {
                    this.changeSearch = true
                    this.params = JSON.parse(filters[0].filtres)
                    this.search()
                }
            },
        },

        mounted: function () {
            this.$store.dispatch('resetRecherchesSauvegardees').then(
                () => this.setRechercheSelectionnee()
            )
        },

        methods: {
            /**
             * Réinitialise les paramètres
             */
            reinit: function () {
                this.params = this.initParams()
            },

            /**
             * Initialise les paramètres
             */
            initParams: function () {
                return {
                    paginate: 15,
                    // Pour l'année fiscale (en juin il faut que ça bascule à l'année suivante)
                    exercice: moment().subtract(5, 'months').year(),
                    actif: 1,
                    typeMissions: [
                        this.$store.state.typeMissions.meuble,
                        this.$store.state.typeMissions.parahotellerie,
                        this.$store.state.typeMissions.hotel,
                        this.$store.state.typeMissions.bureauEquipe
                    ],
                }
            },

            setRechercheSelectionnee: function() {
                this.rechercheSelectionnee = parseInt(this.$router.currentRoute.query.recherche || 0)
            },

            /**
             * Ajout une option vide
             * @param options Array
             * @return Array
             */
            addEmptyOption: function (options) {
                return [{value: '', label: 'Non renseigné'}].concat(options)
            },

            nextStepMailsPersonnalises: function(payload) {
                this.showModalMailsPersonnalise = false
                this.showModalEditMail = {type_id: payload.type_id}
                this.dossiersId = payload.dossiersId
            },

            reloadRechercheSelectionnee: function() {
                this.$store.dispatch('resetRecherchesSauvegardees', this.updateRechercheSelectionnee)
            },

            updateRechercheSelectionnee: function() {
                this.getRecherchesSauvegardees.forEach((rechercheSauvegardee) => {
                    if (_.isEqual(JSON.parse(rechercheSauvegardee.filtres), this.params)) {
                        this.rechercheSelectionnee = rechercheSauvegardee.id
                    }
                })
            },

            removeSearch: function (rechercheSelectionnee) {
                this.$confirm('Êtes-vous certain de vouloir supprimer cette recherche ?').then(() => {
                    axios.delete(`/api/recherches-sauvegardees/${rechercheSelectionnee}`)
                        .then(() => {
                            this.$notify('success', 'La recherche a bien été supprimé.')
                            this.rechercheSelectionnee = null
                            this.$store.dispatch('resetRecherchesSauvegardees')
                        })
                        .catch(() => this.$notify('danger', 'Une erreur est survenue lors de la suppression.'))
                })
            },

        }
    }
</script>
